import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { addPayrollPartnerRoute, sendDocumentRoute } from '../api/constants';
import { onboardPackagesList, payrollpartnersList } from '../constants';
import { jobPostingsKey, profileKey } from '@staffedupusa/shared-components';

type useSendHireDoucmentsProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useSendHireDoucments = ({
    setErrorText,
}: useSendHireDoucmentsProps) => {
    const signedTemplatesKey = 'signedTemplates';
    const client = useQueryClient();
    const { mutate: sendHireDocuments, isLoading: isSendindDocuments } =
        useMutation({
            mutationFn: (variables: {
                template_ids: string;
                application_id: number;
            }) =>
                axiosInstance
                    .post(sendDocumentRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries(signedTemplatesKey);
                    client.invalidateQueries(jobPostingsKey);
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        sendHireDocuments,
        isSendindDocuments,
    };
};
